<section class="detalhe-shell">
  @if (loading() && !product()) {
    <app-ui-detail-page-skeleton />
  } @else if (product(); as p) {
    <app-ui-page-header
      [title]="p.name"
      [subtitle]="productTypeLabel(p.type)"
      [backLink]="['/produtos']"
      backLabel="Produtos"
    >
      <button actions appButton variant="ghost" type="button" (click)="archiveProduct()" aria-label="Arquivar produto">
        <ng-icon name="heroArchiveBoxXMark" size="16" aria-hidden="true" />
        Arquivar
      </button>
    </app-ui-page-header>

    <div class="workspace-grid">
      <main class="workspace-main">
        <section appUiPanelCard class="side-card" aria-label="Imagens do produto">
          <h3 appUiPanelTitle><ng-icon name="heroPhoto" size="16" aria-hidden="true" /> Imagens</h3>
          <app-product-gallery [productId]="p.id" />
        </section>

        <section appUiPanelCard class="commercial-form" aria-label="Informa&ccedil;&otilde;es comerciais">
          <div class="form-section">
            <label class="form-field">
              <span appUiLabel class="uppercase">Descri&ccedil;&atilde;o</span>
              <textarea
                appTextarea
                rows="4"
                [ngModel]="draft().description"
                (ngModelChange)="updateDescription($event)"
                placeholder="Resumo curto que aparece no cat&aacute;logo p&uacute;blico. Diferenciais, benef&iacute;cios, escopo."
                [disabled]="submitting() || !canEdit()"
              ></textarea>
            </label>
          </div>

          <div class="form-section">
            <div class="form-section__head">
              <h2><ng-icon name="heroBanknotes" size="16" aria-hidden="true" /> Cobran&ccedil;a</h2>
              <span appUiHint>Defina valor, moeda e intervalo. Todos opcionais.</span>
            </div>

            <div class="form-row">
              <label class="form-field">
                <span appUiLabel class="uppercase">Valor</span>
                <input
                  appInput
                  type="text"
                  [ngModel]="draft().amount"
                  (ngModelChange)="updateAmount($event)"
                  placeholder="0.00"
                  inputmode="decimal"
                  [disabled]="submitting() || !canEdit()"
                />
              </label>
              <div class="form-field">
                <span appUiLabel class="uppercase">Moeda</span>
                <div
                  appSelect
                  [ngpSelectValue]="draft().currency"
                  (ngpSelectValueChange)="setCurrency($event)"
                  aria-label="Moeda"
                >
                  <span>{{ draft().currency || '-' }}</span>
                  <div *ngpSelectPortal appSelectDropdown>
                    <div appSelectOption [ngpSelectOptionValue]="''">-</div>
                    @for (c of currencyOptions; track c) {
                      <div appSelectOption [ngpSelectOptionValue]="c">{{ c }}</div>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field">
              <span appUiLabel class="uppercase">Intervalo de cobran&ccedil;a</span>
              <div
                appSelect
                [ngpSelectValue]="draft().billing_interval"
                (ngpSelectValueChange)="setBillingInterval($event)"
                aria-label="Intervalo"
              >
                <span>
                  @if (draft().billing_interval) {
                    {{ intervalOptions.find(o => o.value === draft().billing_interval)?.label }}
                  } @else {
                    -
                  }
                </span>
                <div *ngpSelectPortal appSelectDropdown>
                  <div appSelectOption [ngpSelectOptionValue]="''">-</div>
                  @for (opt of intervalOptions; track opt.value) {
                    <div appSelectOption [ngpSelectOptionValue]="opt.value">{{ opt.label }}</div>
                  }
                </div>
              </div>
            </div>

            @if (draft().billing_interval === 'custom') {
              <div class="form-row custom-interval">
                <label class="form-field">
                  <span appUiLabel class="uppercase">A cada</span>
                  <input
                    appInput
                    type="number"
                    min="1"
                    step="1"
                    [ngModel]="draft().custom_interval_value"
                    (ngModelChange)="updateCustomValue($event)"
                    [disabled]="submitting() || !canEdit()"
                  />
                </label>
                <div class="form-field">
                  <span appUiLabel class="uppercase">Unidade</span>
                  <div
                    appSelect
                    [ngpSelectValue]="draft().custom_interval_unit"
                    (ngpSelectValueChange)="setCustomUnit($event)"
                    aria-label="Unidade do intervalo"
                  >
                    <span>{{ customUnitOptions.find(u => u.value === draft().custom_interval_unit)?.label }}</span>
                    <div *ngpSelectPortal appSelectDropdown>
                      @for (u of customUnitOptions; track u.value) {
                        <div appSelectOption [ngpSelectOptionValue]="u.value">{{ u.label }}</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="form-footer">
            @if (dirty() && !submitting()) {
              <button appButton variant="ghost" type="button" (click)="discardChanges()">
                Descartar
              </button>
            }
            <button
              appButton
              variant="primary"
              type="button"
              (click)="submit()"
              [disabled]="submitting() || !dirty() || !canEdit()"
              [title]="saveDisabledReason()"
            >
              {{ submitting() ? 'Salvando...' : 'Salvar alteracoes' }}
            </button>
          </div>
        </section>
      </main>

      <aside class="workspace-side">
        <section appUiPanelCard class="side-card">
          <h3 appUiPanelTitle>Resumo</h3>
          <dl class="resume">
            <div>
              <dt>Status</dt>
              <dd>
                <span appBadge [tone]="p.status === 'archived' ? 'neutral' : 'success'" size="xs">
                  {{ p.status === 'archived' ? 'Arquivado' : 'Ativo' }}
                </span>
              </dd>
            </div>
            <div>
              <dt>Criado em</dt>
              <dd>{{ p.createdAt | date: 'dd/MM/yyyy' }}</dd>
            </div>
            <div>
              <dt>&Uacute;ltima edi&ccedil;&atilde;o</dt>
              <dd>{{ p.updatedAt | date: 'dd/MM/yyyy' }}</dd>
            </div>
          </dl>
        </section>

        @if (suggestions().length > 0) {
          <section appUiPanelCard class="side-card">
            <h3 appUiPanelTitle><ng-icon name="heroLightBulb" size="16" aria-hidden="true" /> Sugest&otilde;es</h3>
            <ul class="suggestions">
              @for (s of suggestions(); track s.text) {
                <li [class.suggest--warn]="s.tone === 'warning'">
                  @if (s.tone === 'warning') {
                    <ng-icon name="heroExclamationTriangle" size="14" aria-hidden="true" />
                  } @else {
                    <ng-icon name="heroSparkles" size="14" aria-hidden="true" />
                  }
                  <span>{{ s.text }}</span>
                </li>
              }
            </ul>
          </section>
        }

        <section appUiPanelCard class="side-card">
          <h3 appUiPanelTitle>Em uso</h3>
          <p appUiPanelText>
            @if (p.in_use_by_active_sales) {
              H&aacute; vendas ativas. Edit bloqueado; arquive para descontinuar.
            } @else {
              Sem vendas ativas no momento.
            }
          </p>
        </section>
      </aside>
    </div>
  }
</section>
